module.exports = __webpack_public_path__ + "static/user-experience-ux-design-sydney-tile-3598d13ab5498666ea92b425aded2326.jpg";